import { Controller } from 'stimulus';

export default class ResourceShowSidebarController extends Controller {}
